import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { CheckboxProps } from '../Checkbox';

type LabelWrapperProps = Pick<CheckboxProps, 'disabled'>;

export const LabelWrapper = styled.label<LabelWrapperProps>`
    grid-column-start: 1;
    grid-column-end: 3;
    display: grid;
    grid-template-columns: 18px minmax(0, 1fr);
    grid-column-gap: ${theme.space[8]};
    position: relative;
    align-items: center;
    min-width: 0;
    user-select: none;
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};

    // required to override global styles
    margin-bottom: 0;
    font-weight: ${theme.fontWeights[500]};

    & > input:focus-visible + div {
        box-shadow: ${theme.shadows.focus};
    }
`;
